import { render } from "./Trend.vue?vue&type=template&id=77978d6e"
import script from "./Trend.vue?vue&type=script&lang=js"
export * from "./Trend.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__